<template>
  <div class="l-main-layout" :class="data.staticClass">
    <div class="l-main-layout__default">
      <slot />
    </div>
    <div class="l-main-layout__aside" v-if="$slots.aside">
      <slot name="aside" />
    </div>
    <div class="l-main-layout__equal" v-if="$slots.equal">
      <slot name="equal" />
    </div>
  </div>
</template>
<style>
.l-main-layout {
  display: flex;
  flex-direction: row;

  margin-bottom: var(--main-pad);
  &:last-child { margin-bottom: 0 }

  > * {
    margin-left: var(--main-pad);
    width: 100%;
    flex-grow: 1;
    max-width: 1200px;

    &:first-child {
      margin-left: 0;
    }
  }

  &__aside {
    min-width: 367px;
    max-width: 367px;
    flex-grow: 0;
  }

  &__default > * {
    margin-bottom: var(--main-pad);

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>